<template>
  <div class="row">
    <div class="col-12 py-3">
      <div class="btn-group float-end">
        <a type="button" class="btn btn-primary bg-gray" @click="$emit('setMyTasks')" :class="{'active' : myTasksActive}">
          <i class="fas fa-check-circle"></i>
          Minhas tarefas
        </a>
        <a v-if="userAdmin === 1" type="button" class="btn btn-primary bg-gray" @click="$emit('newBucket')">
          <i class="fas fa-plus-circle"></i>
          Novo quadro
        </a>
        <a v-if="userAdmin === 1" type="button" class="btn btn-primary bg-gray" @click="$emit('setModalExportShow')">
          <i class="fas fa-cloud-download-alt"></i>
          Exportar
        </a>
        <app-board-view-options :properties="data.task_model" :viewProperties="viewVariablesMiniCard"
          @setBoardPropertiesMini="setBoardProperties" />

      </div>



    </div>
    <div class="bucket-list" v-if="buckets.length">
      <Container orientation="horizontal" @drop="onBucketDrop" drag-handle-selector=".column-drag-handle"
        @drag-start="dragStart" :drop-placeholder="upperDropPlaceholderOptions">
        <Draggable v-for="(bucket, index) in buckets" :key="bucket.id" class="bucket-item">
          <div class="card">
            <app-board-name :bucket="bucket" :position="index" :total="buckets.length" :userAdmin="userAdmin"
              @setBucketName="setBucketName" @moveBucket="moveBucket" @deleteBucket="deleteBucket" />

            <div class="card-body py-0 px-0 mb-3" v-if="userAdmin">
              <a @click="createNewTask(bucket.id)" class="btn btn-primary bg-gray w-100 waves-effect waves-light">
                <i class="mdi mdi-plus me-1"></i> Criar
              </a>
            </div>
          </div>
          <Container group-name="col" @drop="(e) => onTaskDrop(bucket.id, e)"
            @drag-start="(e) => log('drag start (task)', e)" @drag-end="(e) => log('drag end (task)', e)"
            :get-child-payload="getTaskPayload(bucket.id)" drag-class="card-ghost" drop-class="card-ghost-drop"
            :drop-placeholder="dropPlaceholderOptions">
            <Draggable v-for="task in bucket.tasks" :key="task.id">
              <app-mini-card :key="task.id" :item="task" :index="index" :properties="data.task_model"
                :viewProperties="viewVariablesMiniCard" :data-id="task.id" :data-bucket="bucket.id"
                :userAdmin="userAdmin" data-type="ativo" @openForm="modalForm" @deleteTask="deleteTask"
                @copyTask="copyTask" @taskUpdateStatus="taskUpdateStatus" />
            </Draggable>
          </Container>
          <!-- Completes -->
          <template v-if="bucket.taskCompletes && bucket.taskCompletes.length">
            <div class="card-body mb-3">
              <h4 class="card-title mb-0 font-size-12 tarefas-conluidas active">({{ bucket.taskCompletes.length }})
                Tarefas concluídas</h4>
            </div>
            <app-mini-card v-for="completo in bucket.taskCompletes" :key="completo.id" :item="completo" :index="index"
              :data-id="completo.id" :userAdmin="userAdmin" data-type="completo" @openForm="modalForm"
              @deleteTask="deleteTask" @copyTask="copyTask" @taskUpdateStatus="taskUpdateStatus" />
          </template>
        </Draggable>
      </Container>
    </div>
  </div>
</template>

<script>
import { Container, Draggable } from "vue-smooth-dnd";
import AppMiniCard from "./MiniCard.vue";
import AppBoardName from "./BoardName.vue";
import AppBoardViewOptions from "./BoardViewOptions.vue";

export default {
  name: "CardBoard",
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    buckets: {
      type: Array,
      default: () => []
    },
    userAdmin: {
      type: Number,
      default: 0
    },
    myTasksActive:{
      type: Boolean,
      default: false
    }
  },

  components: {
    Container,
    Draggable,
    AppBoardName,
    AppMiniCard,
    AppBoardViewOptions
  },

  data() {
    return {
      upperDropPlaceholderOptions: {
        showOnTop: true
      },
      dropPlaceholderOptions: {
        showOnTop: true
      },
      viewVariablesMiniCardFake: [],
      viewVariablesMiniCard: []
    };
  },
  watch: {
    data: {
      handler() {
        console.log("handler Data ativado 2");
        this.getBoardProperties();
      },
      immediate: true
    },
    buckets: {
      handler() {
        console.log("handler buckets ativado in board templates");
        this.getBoardProperties();
      },
      immediate: true
    }
  },
  methods: {
    applyDrag(arr, dragResult) {
      const { removedIndex, addedIndex, payload } = dragResult;
      if (removedIndex === null && addedIndex === null) return arr;
      const result = [...arr];
      let itemToAdd = payload;
      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0];
      }

      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd);
      }

      return result;
    },

    onBucketDrop(dropResult) {
      const buckets = [...this.buckets];
      this.buckets = this.applyDrag(buckets, dropResult);
      this.notifyApi(this.buckets);
    },

    onTaskDrop(bucketId, dropResult) {
      if (dropResult.removedIndex !== null || dropResult.addedIndex !== null) {
        const bucket = this.buckets.find(b => b.id === bucketId);
        const columnIndex = this.buckets.indexOf(bucket);

        const newTasks = this.applyDrag(bucket.tasks, dropResult);
        this.$set(this.buckets[columnIndex], "tasks", newTasks);
        this.updateTaskOrder(bucketId, newTasks);
        this.notifyApi(bucket); // apenas o bucket afetado é atualizado
      }
    },

    updateTaskOrder(bucketId, tasks) {
      tasks.forEach((task, index) => {
        task.ordered = index + 1;
        task.bucket_id = bucketId;
      });
    },

    getTaskPayload(bucketId) {
      return taskIndex => {
        const bucket = this.buckets.find(b => b.id === bucketId);
        return bucket.tasks[taskIndex];
      };
    },

    dragStart() {
      console.log("drag started");
    },

    log(...params) {
      console.log(...params);
    },

    /*modalForm(index, id) {

      this.$emit("openForm", index, id);
    },*/
    modalForm(bucket, id) {
      this.$emit("openForm", bucket, id);
    },
    setBucketName(bucket) {
      this.$emit("setBucketName", bucket);
    },

    moveBucket(index, direction) {
      this.$emit("moveBucket", index, direction);
    },

    deleteBucket(id) {
      this.$emit("deleteBucket", id);
    },

    createNewTask(id) {
      this.$emit("createNewTask", id);
    },

    deleteTask(bucket, id) {
      this.$emit("deleteTask", bucket, id);
    },
    copyTask(bucket, id) {
      console.log("copyTask - board template", bucket, id);
      this.$emit("copyTask", bucket, id);
    },
    taskUpdateStatus(bucket, id, value) {
      this.$emit("taskUpdateStatus", bucket, id, value);
    },

    // Função para notificar a API
    notifyApi(updatedBuckets) {
      this.$emit("updateBucketData", updatedBuckets);
    },
    getBoardProperties() {
      const board = this.$route.params.id;
      if (!board) return; // Retorna se não houver um `board` selecionado

      // Obtenha a string do local storage
      const atuaisString = this.$ls.get(`properties-view-${board}`);

      // Se a string está vazia ou nula, converte para um array
      const atuais = atuaisString ? JSON.parse(atuaisString) : [];
      this.viewVariablesMiniCard = atuais;
    },
    setBoardProperties(propertie) {
      const board = this.$route.params.id;
      const atuais = [...this.viewVariablesMiniCard];
      const lsName = `properties-view-${board}`;
      const index = atuais.indexOf(propertie);
      if (index === -1) {
        atuais.push(propertie);
      } else {
        atuais.splice(index, 1);
      }
      this.viewVariablesMiniCard = atuais;
      this.$ls.set(lsName, JSON.stringify(atuais));
      this.getBoardProperties();
    }
  }
};
</script>
<style scoped>
.my-card-footer {
  border-top: 2px solid #f1f2f3 !important;
}

.smooth-dnd-container.horizontal {
  display: block;
}

.smooth-dnd-container.vertical {
  min-height: 130px;
}

.smooth-dnd-container.horizontal>.smooth-dnd-draggable-wrapper {
  display: inline-block;
}

.smooth-dnd-container.vertical>.smooth-dnd-draggable-wrapper {
  min-height: 130px;
}
</style>